export default "__VITE_ASSET__iSVJsc7Y__"